import {
  Brands,
  BrandsStatusOptions,
  BrandsSyncStatusOptions,
  BrandsToneOptions,
  BrandsTypeOptions,
  BrandsVisualStyleOptions,
} from "./pocketbase-types";

// Define as an enum so it exists both as a type and a value at runtime
export enum ContentObjectiveGoals {
  BrandAwareness = "brand_awareness",
  EducateAudience = "educate_audience",
  DriveSales = "drive_sales",
  InternalKnowledge = "internal_knowledge",
  ImproveSEO = "improve_seo",
  BuildCommunity = "build_community",
}

export interface Product {
  productName: string;
  productUrl: string;
}

export interface Competitor {
  name: string;
  url: string;
}

export interface Brand
  extends Omit<
    Brands,
    "created" | "updated" | "contentObjectives" | "products" | "competitors"
  > {
  contentObjectives: { goals: ContentObjectiveGoals[] };
  products?: Product[];
  competitors?: Competitor[];
}

export enum ImageVisualStyleOptions {
  Photorealistic = "photorealistic",
  FlatIllustration = "flat illustration",
  Abstract = "abstract",
  Watercolor = "watercolor",
  HandDrawnSketch = "hand-drawn sketch",
  VectorArt = "vector art",
  CutoutCollage = "cutout collage",
  ThreedRendered = "3d rendered",
}

export const defaultOnboardingData: Brand = {
  // Step 1
  id: "",
  url: "",

  // Step 2
  name: "",
  logo: "",
  primaryColor: "#3b82f6", // Default blue
  secondaryColor: "#f97316", // Default orange
  description: "",
  targetAudience: "",
  status: BrandsStatusOptions.Active,
  tone: BrandsToneOptions.Professional,
  contentObjectives: { goals: [] },
  uniqueValue: "",
  additionalNotes: "",
  analyticsId: "",
  analyticsViewId: "",
  searchConsoleVerified: false,
  lastSyncAt: "",
  syncStatus: BrandsSyncStatusOptions.Pending,
  language: "English", // Default language
  location: "", // Will be populated during onboarding
  imageStyle: {
    embedLogo: false,
    referenceImage: null,
    logoPlacement: "top-right",
    visualStyles: [],
  },

  // Step 3
  products: [],

  // Step 4
  competitors: [],

  // Step 5
  visualStyle: BrandsVisualStyleOptions.MinimalAbstract,

  // Required properties from Brands interface
  type: BrandsTypeOptions.Custom, // Default to custom
  org: "", // Will be populated from the current user's org
  domain: "", // Will be extracted from URL during onboarding
};
